function AplikSoftverVEIi(){
    return(
        <div>
            AplikSoftverVEIi
        </div>
    );
};

export default AplikSoftverVEIi;